import { render } from "./trainersSlider.vue?vue&type=template&id=10af304c"
import script from "./trainersSlider.vue?vue&type=script&lang=js"
export * from "./trainersSlider.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__